import { render, staticRenderFns } from "./RenderingConfiguration.vue?vue&type=template&id=962410f2&scoped=true"
import script from "./RenderingConfiguration.vue?vue&type=script&lang=js"
export * from "./RenderingConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RenderingConfiguration.vue?vue&type=style&index=0&id=962410f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962410f2",
  null
  
)

export default component.exports